import React from "react";
import { Box, Flex, Text, useColorModeValue as mode } from "@chakra-ui/react";

const MessageRow = ({ text, direction, toNumber, fromNumber, date, time, index, header }) => {
  return (
    <Flex direction='column' bg={index % 2 === 0 ? mode("white", "gray.800") : mode("gray.100", "gray.700")}>
      <Text fontSize='xs' textAlign={direction === 0 ? "left" : "right"} color={mode("gray.600", "gray.400")}>
        {date} at {time} | {direction === 0 ? "To" : "From"}: {direction === 0 ? toNumber : fromNumber}
      </Text>
      <Flex
        bg={index % 2 === 0 ? mode("white", "gray.800") : mode("gray.100", "gray.700")}
        align='center'
        justify='start'
        borderBottom='1px solid'
        borderColor={mode("gray.200", "gray.600")}
        alignItems='stretch'
      >
        <Box flex='1' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
          <Text
            textAlign={direction === 0 ? "left" : "right"}
            fontWeight={header ? "bold" : "normal"}
            p={1}
            color={header ? "" : direction === 0 ? mode("blue", "blue.300") : mode("red", "red.300")}
          >
            <span dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, "<br />") }} />
          </Text>
        </Box>
        {/* <Box flex='1' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {time}
        </Text>
      </Box>
      <Box flex='1' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {status}
        </Text>
      </Box>
      <Box flex='3' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text flex='2' textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {title}
        </Text>
      </Box>
      <Box flex='6' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text flex='4' textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {description}
        </Text>
      </Box> */}
      </Flex>
    </Flex>
  );
};

export default MessageRow;
